import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuthError, LoginRequest, User } from '../interfaces/auth.interface';
import { SignUpPayload } from '../../../shared/interfaces/sign-up.inteerface';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    Login: props<LoginRequest>(),

    Signup: props<SignUpPayload>(),

    Logout: emptyProps(),
  },
});

export const AuthApiActions = createActionGroup({
  source: 'Auth API',
  events: {
    'Login Success': props<{ user: User }>(),
    'Login Failure': props<{ error: AuthError }>(),

    'Signup Success': props<{ user: User }>(),
    'Signup Failure': props<{ error: AuthError }>(),

    'Logout Success': emptyProps(),
    'Logout Failure': props<{ error: AuthError }>(),
  },
});
